import React, { useEffect } from "react";
import { Route, Routes, useNavigate, Navigate } from "react-router-dom";
import { UnoStoreHooks } from "@simulanisindia/ui";
import Home from "./Dashboard/Home.jsx";
import ResourceManagement from "../pages/ResourceManagement/ResourceManagement";
import AccountSetting from "../pages/AccountSetting/AccountSetting";
import TeamApplicationManagement from "../pages/TeamManagement/TeamApplicationManagement";
import Feedback from "../pages/FeedAndSurveyMngt/Feedback";
import FeedBackPreview from "../pages/FeedBackPreview";
import EditCreateQuestions from "../pages/FeedAndSurveyMngt/feedbacksurveycomp/EditCreateQuestions";
import FeedbackDetail from "../pages/FeedAndSurveyMngt/feedbacksurveycomp/FeedbackDetail";
import CreateQuestions from "../pages/FeedAndSurveyMngt/feedbacksurveycomp/CreateQuestions";
import TeamManagement from "./TeamManagement/TeamManagement.js";
import TeamUserManagement from "./TeamManagement/TeamUserManagement.js";
import RoleManagement from "../pages/RoleManagement/RoleManagement.js";
import ManagePermission from "../pages/RoleManagement/ManagePermission.js";
import CreateRole from "../pages/RoleManagement/CreateRole.js";
import TabRole from "../pages/RoleManagement/TabRole.js";
import ResetPassword from "../pages/ResetPassword.js";
import ResourceManagementTemp from "../pages/ResourceManagement_N/ResourceManagement_N.jsx";
import ResourceManagement_N from "../pages/ResourceManagement_N/ResourceManagement_N.jsx";

const { useUnoSelector } = UnoStoreHooks;

const AppRouter = ({ isMobileView }) => {
  const userData = useUnoSelector((state) => state.user);

  return (
    <Routes>
      <Route path="/dashboard/:uuid" element={<Home isMobileView={isMobileView} />} />
      <Route path="/team-management/:uuid" element={<TeamManagement isMobileView={isMobileView} />} />
      <Route path="/team-management/:type/:uuid" element={<TeamUserManagement isMobileView={isMobileView} />} />
      <Route path="/team-management/Application/:uuid" element={<TeamApplicationManagement isMobileView={isMobileView} />} />
      
      <Route path="/resource-management" element={<ResourceManagement_N isMobileView={isMobileView} />} />
      <Route path="/resource-management/:type/:uuid" element={<ResourceManagement_N isMobileView={isMobileView} />} />


      {/* <Route path="/resource-management/:uuid" element={<ResourceManagement isMobileView={isMobileView} />} />
      <Route path="/resource-management/:type/:uuid" element={<ResourceManagement isMobileView={isMobileView} />} /> */}
      
      
      <Route path="/roles" element={<RoleManagement isMobileView={isMobileView} />} />
      {/* <Route path="/roles/permission/view" element={<TabRole isMobileView={isMobileView} />} /> */}
      <Route path="/roles/create" element={<CreateRole isMobileView={isMobileView} />} />
      <Route path="/roles/permission/manage/:uuid" element={<ManagePermission isMobileView={isMobileView} />} />
      <Route path="/roles/permission/view/:uuid" element={<ManagePermission onlyView={true} isMobileView={isMobileView} />} />

      <Route path="/manage/account/:uuid" element={<AccountSetting isMobileView={isMobileView} />} />
      <Route path="/feedback/:uuid" element={<Feedback />} />
      <Route path="/feedback/feedback/detail/:uuid" element={<FeedbackDetail />} />
      <Route path="/feedback/create/:uuid" element={<CreateQuestions />} />
      <Route path="/feedback/edit-create-questions" element={<EditCreateQuestions />} />
      <Route path="/feedback/feedback-preview/:uuid" element={<FeedBackPreview />} />
      <Route path="*" element={<Navigate to={`/dashboard/${userData.user.uuid}`} />} />
    </Routes>
  );
};

export default AppRouter;
